export const DASHBOARD_COLORS = {
  revenue: "#059669",
  revenueLight: "#a7f3d0",
  expenses: "#0ea5e9",
  expensesLight: "#bae6fd",
  neutral: "#94a3b8",
  warning: "#f59e0b",
  danger: "#ef4444",
  muted: "#cbd5f5",
};

export const INVOICE_STATUS_COLORS = {
  paid: DASHBOARD_COLORS.revenue,
  sent: DASHBOARD_COLORS.revenueLight,
  created: DASHBOARD_COLORS.neutral,
  overdue: DASHBOARD_COLORS.warning,
  cancelled: DASHBOARD_COLORS.danger,
  unknown: DASHBOARD_COLORS.muted,
};

export const DASHBOARD_SPARKLINE_COLORS = {
  revenue: DASHBOARD_COLORS.revenue,
  expenses: DASHBOARD_COLORS.expenses,
  profit: DASHBOARD_COLORS.revenue,
};
